import React, { useState } from "react";
import axios from "axios";
import { Bell, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Card } from "./ui/card";
import { useI18n } from "../lib/i18n";
import { API } from "../lib/auth";
import { toast } from "sonner";

export default function AlertSubscribe({ keyword, location }) {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/alerts/subscribe`, { email, keyword, location });
      toast.success(t("jobs.subscribeSuccess"));
      setEmail("");
    } catch (err) { toast.error("Failed"); }
    setLoading(false);
  };

  return (
    <Card className="p-6 bg-slate-900 text-white border-slate-800" data-testid="alert-subscribe">
      <div className="flex items-start gap-4">
        <div className="h-12 w-12 rounded-full bg-[#1A8FE3]/20 flex items-center justify-center shrink-0">
          <Bell className="h-5 w-5 text-[#1A8FE3]" />
        </div>
        <div className="flex-1">
          <h3 className="font-display text-xl font-semibold">{t("jobs.subscribeTitle")}</h3>
          <form onSubmit={submit} className="mt-4 flex gap-2">
            <Input data-testid="alert-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" className="bg-white text-slate-900" />
            <Button type="submit" disabled={loading} data-testid="alert-submit" className="bg-[#1A8FE3] hover:bg-[#157AC0] text-white rounded-full whitespace-nowrap">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("jobs.subscribeCta")}
            </Button>
          </form>
        </div>
      </div>
    </Card>
  );
}
